var DialogUsersModule = /** @class */ (function () {
    function DialogUsersModule() {
    }
    return DialogUsersModule;
}());
export { DialogUsersModule };
